import React from 'react';
import { func, string, number, oneOfType, bool } from 'prop-types';
import Radium from 'radium';
import { UTButton, UTLabel } from '@widergy/energy-ui';

import SecondaryTopbar from '../../../../../../components/SecondaryTopbar';
import numeral from '../../../../../../../config/numeral';
import { appConfig } from '../../../../../../../config/customization';
import { message } from '../../../../../../../utils/stringUtils';

import stylesJS from './styles';
import styles from './styles.module.scss';

function PaymentsHeader({
  totalAmount,
  totalAmountText,
  secondaryTopbarText,
  handlePressFirstButton,
  handlePayment,
  handleExternalAccPayment,
  isPublic
}) {
  return (
    <div>
      <SecondaryTopbar titleText={secondaryTopbarText} />
      <div style={stylesJS.container}>
        <div style={stylesJS.amountSection}>
          <UTLabel>{totalAmountText}</UTLabel>
          <UTLabel extrabold alternative style={stylesJS.superBigSize}>
            {numeral(totalAmount).format('$0,0.[00]')}
          </UTLabel>
        </div>
        <div
          style={
            appConfig.clientSummary.selectAllAccounts
              ? stylesJS.buttonsSection
              : stylesJS.paymentButtonSection
          }
        >
          {appConfig.clientSummary.selectAllAccounts && handlePressFirstButton && (
            <UTButton secondary style={stylesJS.buttons} onPress={handlePressFirstButton}>
              {message('ClientSummary:selectText')}
            </UTButton>
          )}
          {appConfig.payments.active && (
            <UTButton
              className={appConfig.clientSummary.selectAllAccounts ? styles.buttons : styles.paymentButton}
              onPress={handlePayment}
              disabled={totalAmount === 0}
            >
              {message('ClientSummary:paymText')}
            </UTButton>
          )}
          {appConfig.payExternalAcc && !isPublic && (
            <UTButton className={styles.paymentButton} onPress={handleExternalAccPayment}>
              {message('ClientSummary:payAnotherAcc')}
            </UTButton>
          )}
        </div>
      </div>
    </div>
  );
}

PaymentsHeader.propTypes = {
  isPublic: bool,
  secondaryTopbarText: string.isRequired,
  totalAmountText: string.isRequired,
  totalAmount: oneOfType([string, number]).isRequired,
  handlePressFirstButton: func,
  handlePayment: func.isRequired,
  handleExternalAccPayment: func.isRequired
};

export default Radium(PaymentsHeader);
